import { Link } from "react-router-dom";
import CardInfoRow from "../../../../components/CardInfo/CardInfoRow/CardInfoRow";
import "./CourseProfessorData.css";
import { Button, Center } from "@mantine/core";

const CourseProfessorData = ({ data }) => {

    if (!data.about.description && (!data.about.personalItems || data.about.personalItems?.length === 0)) return <></>

    return (
        <div className="courseProfessorInfo-main-wrapper-section-div">
            {data?.about?.description && (
                <div className="courseProfessorInfo-third-section-div">
                    <div className="courseProfessorInfo-third-section-div-content-container">
                        <h5 className="courseProfessorInfo-third-section-title-h5">
                            Sobre mí
                        </h5>
                        <p className="courseProfessorInfo-second-section-ul-p">
                            {data.about.description}
                        </p>
                    </div>
                </div>
            )}
            <hr style={{ opacity: '.3' }} />
            {data?.about?.personalItems?.length > 0 && (
                <div className="courseProfessorInfo-second-section-div">
                    <div className="courseProfessorInfo-second-section-div-content-container">
                        <ul className="courseProfessorInfo-second-section-ul-list">
                            {data.about.personalItems.map((item, i) => (
                                <li key={i}>
                                    <p className="courseProfessorInfo-second-section-ul-p">
                                        {item.item.toLowerCase() !== 'otro' && <span>{item.item}:</span>} {item.value}
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </div>

                </div>
            )}



            <Center>
                {data.slugName && <Button
                    mt={32}
                    component={Link}
                    to={`/profesores/${data.slugName}`}
                    target="_blank"
                    variant="outline"
                >
                    Ver perfil de<span style={{ textTransform: 'capitalize', marginLeft: '.3rem' }}>{data.name.toLowerCase()}</span>
                </Button>}
            </Center>
        </div>
    );
};

export default CourseProfessorData;
